import { lazy, Suspense, useState } from 'react';
import { MessageCircle, Loader2 } from 'lucide-react';
const AgentChatWidget = lazy(() => import('@/components/agent/AgentChatWidget'));

export default function OnDemandChat({ en = false }) {
  const [requested, setRequested] = useState(false);
  const [open, setOpen] = useState(false);
  const launcher = <button type="button" onClick={() => { setOpen(true); setRequested(true); }}
    aria-label={requested ? (en ? 'Loading chat' : 'Indlæser chat') : (en ? 'Open chat' : 'Åbn chat')}
    aria-busy={requested} disabled={requested}
    className="fixed bottom-5 right-5 z-[400] w-14 h-14 rounded-full bg-ee-brand text-ee-on-brand shadow-xl flex items-center justify-center">
    {requested ? <Loader2 className="w-6 h-6 animate-spin" /> : <MessageCircle className="w-6 h-6 text-ee-gold" />}
  </button>;
  return requested ? <Suspense fallback={launcher}><AgentChatWidget open={open} onOpenChange={setOpen} /></Suspense> : launcher;
}